var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-form"},[_c('p',{staticClass:"main-title"},[_vm._v(_vm._s(_vm.mainTitle))]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }